import { useTranslation } from 'react-i18next';

// The values are the API contract; the labels come from the dictionary at render time.
// A `t()` call in a module-level array would run once, at import, and never follow the language.
const CONVERSATION_TYPES = ['TextConversation', 'AnalyticsCall', 'AgentCall'] as const;
const SCORES = ['low', 'medium', 'high'] as const;
const SCORE_TYPES = ['numeric', 'text'] as const;
const SURVEY_CATEGORIES = ['regular', 'redirect'] as const;

export const useConversationTypeOptions = () => {
  const { t } = useTranslation('surveys');
  return CONVERSATION_TYPES.map((value) => ({ value, label: t(`conversationType.${value}`) }));
};

export const useScoreOptions = () => {
  const { t } = useTranslation('surveys');
  return SCORES.map((value) => ({ value, label: t(`scoreOption.${value}`) }));
};

export const useScoreTypeOptions = () => {
  const { t } = useTranslation('surveys');
  return SCORE_TYPES.map((value) => ({ value, label: t(`scoreType.${value}`) }));
};

export const useSurveyCategoryOptions = () => {
  const { t } = useTranslation('surveys');
  return SURVEY_CATEGORIES.map((value) => ({ value, label: t(`category.${value}`) }));
};
